export const ACCIONES_A_CONFIRMAR = {
  ACTIVAR: 'activar',
  DESACTIVAR: 'desactivar',
  ELIMINAR: 'eliminar',
};

export const SUSTANTIVOS_ACCIONES_A_CONFIRMAR = {
  [ACCIONES_A_CONFIRMAR.ACTIVAR]: 'Activación',
  [ACCIONES_A_CONFIRMAR.DESACTIVAR]: 'Desactivación',
  [ACCIONES_A_CONFIRMAR.ELIMINAR]: 'Eliminación',
};

export const ACCIONES_CRUD = {
  VER: 'ver',
  REGISTRAR: 'registrar',
  EDITAR: 'editar',
};

export const TIPOS_INSTITUCIONES = {
  UNIVERSIDAD: 'U',
  INSTITUTO: 'I',
};

export const ESTADOS_INSCRIPCION = {
  0: 'Preinscrito',
  1: 'Inscrito',
  2: 'Retirado',
  3: 'Cambiado',
  4: 'Congelado',
  5: 'Pagado',
};

export const COLORES_ESTADOS_INSCRIPCION = {
  0: 'blue',
  1: 'green',
  2: 'red',
  3: 'orange',
  4: 'grey',
  5: 'success',
};

export const ESTADOS_INCRIPCIONES_ENUM = {
  PREINSCRITO: 'preinscrito',
  INSCRITO: 'inscrito',
  RETIRADO: 'retirado',
  CAMBIADO: 'cambiado',
  CONGELADO: 'congelado',
};

export const TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS = {
  SEDE: 'sede',
  NACIONAL: 'nacional',
};

export const ESTADOS_SOLICITUDES_INSCRIPCIONES = {
  PENDIENTE: 'pendiente',
  APROBADA: 'aprobada',
  RECHAZADA: 'rechazada',
};

export const ESTADOS_PROGRAMAS_UNIVERSIDADES = {
  PENDIENTE: 'pendiente',
  INSCRITO: 'inscrito',
  NO_EJECUTADO_O_DISPONIBLE: 'no_ejecutado_disponible',
};

export const ESTADOS_PROGRAMAS_UNIVERSIDADES_LABELS = {
  [ESTADOS_PROGRAMAS_UNIVERSIDADES.PENDIENTE]: 'Pendiente de inscripción',
  [ESTADOS_PROGRAMAS_UNIVERSIDADES.INSCRITO]: 'Inscrito',
  [ESTADOS_PROGRAMAS_UNIVERSIDADES.NO_EJECUTADO_O_DISPONIBLE]: 'No ejecutado / Disponible',
};

export const ESTADOS_PROGRAMAS_UNIVERSIDADES_COLORES = {
  [ESTADOS_PROGRAMAS_UNIVERSIDADES.PENDIENTE]: 'orange',
  [ESTADOS_PROGRAMAS_UNIVERSIDADES.INSCRITO]: 'success',
  [ESTADOS_PROGRAMAS_UNIVERSIDADES.NO_EJECUTADO_O_DISPONIBLE]: 'red',
};

export const TIPO_VERIFICACION_SOLICITUDES_PAGOS = {
  POR_CONCEPTO: 'por concepto',
  POR_EL_TOTAL: 'por el total',
};

export const FASES_PROGRAMA = {
  0: 'NO APROBADO',
  1: 'INSCRIPCIONES',
  2: 'EN DESARROLLO',
  3: 'CONCLUIDO',
  4: 'ELABORACION TRABAJOS FINALES',
  5: 'RECEPCION DE REQUISITOS DE TITULACION',
  6: 'ARMADO CARPETAS',
  7: 'PAGO ARANCELES',
  8: 'PROCESO TITULACION',
  9: 'CERTIFICADOS ENTREGADOS',
  10: 'NO EJECUTADO',
};

export const ESTADOS_CARTERA = {
  'Exento de deuda': 'Exento de deuda',
  Vigente: 'Vigente',
  Retrasado: 'Retrasado',
  'Riesgo de incobrabilidad': 'Riesgo de incobrabilidad',
  'En mora': 'En mora',
  'Sin clasificar': 'Sin clasificar',
  'Retirado Exento de deuda': 'Retirado Exento de deuda',
};

export const COLORES_ESTADOS_CARTERA = {
  'Exento de deuda': 'green',
  Vigente: 'blue',
  Retrasado: 'orange',
  'Riesgo de incobrabilidad': 'red',
  'En mora': 'red',
  'Sin clasificar': 'grey',
  'Retirado Exento de deuda': 'grey',
};

export const ESTADOS_ADMINISTRATIVOS = {
  Prospecto: 'Prospecto',
  Preinscrito: 'Preinscrito',
  Inscrito: 'Inscrito',
  'Inscrito Transferido': 'Inscrito Transferido',
  Retirado: 'Retirado',
  'Retirado Cambiado': 'Retirado Cambiado',
};

export const COLORES_ESTADOS_ADMINISTRATIVOS = {
  Prospecto: 'grey',
  Preinscrito: 'blue',
  Inscrito: 'green',
  'Inscrito Transferido': 'green',
  Retirado: 'red',
  'Retirado Cambiado': 'orange',
};

export const ESTADOS_ACADEMICOS = {
  Vigente: 'Vigente',
  'No Vigente': 'No Vigente',
  'En Desarrollo': 'En Desarrollo',
  'Concluido Aprobado': 'Concluido Aprobado',
  'Elaboracion Trabajo': 'Elaboracion Trabajo',
  'Aprobado Trabajo Final': 'Aprobado Trabajo Final',
  'Elaboracion de Trabajo': 'Elaboracion de Trabajo',
  'Entrega de Trabajo': 'Entrega de Trabajo',
  Presentado: 'Presentado',
  'Pre-Defensa': 'Pre-Defensa',
  Congelado: 'Congelado',
  Retirado: 'Retirado',
  Cambio: 'Cambio',
  Reprobado: 'Reprobado',
  'Abandono Académico': 'Abandono Académico',
  Grupo: 'Grupo',
  Version: 'Version',
  'Defensa Final': 'Defensa Final',
  Modular: 'Modular',
  'En Desarrollo - Nivelacion': 'En Desarrollo - Nivelacion',
};

export const COLORES_ESTADOS_ACADEMICOS = {
  Vigente: 'blue',
  'No Vigente': 'red',
  'En Desarrollo': 'light-green',
  'Concluido Aprobado': 'success',
  'Elaboracion Trabajo': 'orange',
  'Aprobado Trabajo Final': 'green',
  'Elaboracion de Trabajo': 'orange',
  'Entrega de Trabajo': 'orange',
  Presentado: 'blue',
  'Pre-Defensa': 'blue',
  Congelado: 'grey',
  Retirado: 'red',
  Cambio: 'orange',
  Reprobado: 'red',
  'Abandono Académico': 'red',
  Grupo: 'blue',
  Version: 'blue',
  'Defensa Final': 'gray',
  Modular: 'orange',
  'En Desarrollo - Nivelacion': 'cyan',
};
